
import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import Markdown from 'marked-react';
import './nextgpt.scss';

function QAPerformance(props) {
    let accumulatedData = '';
    let remainedData = null;

   const {setDataAvailable, setChartData} = props
   const [genstateQA, setGenstateQA] = useState('notgen');
   const [qaPerfData, setQAPerfData] = useState('');
   const [isSendtoRM, setSendToRM] = useState(false);

   var qaPerfData_local = localStorage.getItem('qaPerfData_local');
   useEffect(() => {
       //console.log(qaPerfData_local)
       if (qaPerfData_local !== null) {
        if (genstateQA ==='notgen'){
            document.getElementById('generatingBtn').style.visibility = 'hidden';
            document.getElementById('generatingBtn').style.display = 'none';
            setSendToRM(true);
        }  
           setQAPerfData(qaPerfData_local);
       }
           
   }, [qaPerfData_local])

   const extractDataFromTable = () => {
    const tables = document.querySelectorAll('.qaPerformanceTable table');
    if (!tables.length) {
      setDataAvailable(false);
      return [];
    }
  
    const data = Array.from(tables).flatMap(table => {
      const rows = Array.from(table.getElementsByTagName('tr'));
      return rows.slice(1).map(row => { // Skip the header row
        const cells = row.getElementsByTagName('td');
        return {
          Standard: cells[0].textContent.trim(),
          Score: cells[1].textContent.trim() === 'Fail' ? 0 : 100
        };
      });
    });
  
    setDataAvailable(true);
    console.log('finish extract from tables');
    return data;
  };
  const extractDataFromText = () => {
    const textContainer = document.querySelector('.qaPerformanceTable');
    if (!textContainer) {
      setDataAvailable(false);
      return [];
    }
  
    const textContent = textContainer.innerHTML;
    const standards = [
      "Professionalism",
      "Transparency",
      "Confidentiality",
      "Compliance",
      "Customer Service",
      "Fairness",
      "Integrity",
      "Record Keeping",
      "Training",
      "Continuous Improvement"
    ];
  
    const data = standards.map(standard => {
      const regex = new RegExp(`<h2>${standard}</h2>\\s*<p><strong>Score: (\\w+)</strong>`, 's');
      const match = textContent.match(regex);
  
      if (match) {
        const score = match[1] === 'Fail' ? 0 : 100;
        return {
          Standard: standard,
          Score: score
        };
      }
  
      return {
        Standard: standard,
        Score: 0,
      };
    });
  
    setDataAvailable(true);
    console.log('finish extract from text');
    return data;
  };
  
  
  const extractData = () => {
    let data = extractDataFromTable();
    if (!data.length) {
      data = extractDataFromText();
    }
    return data;
  };
  
    
      // Call the extraction function based on a condition, for example, when qaActive changes
        
    const callNextGpt = async (usecase, file) => {
        var dataResponse;

        const formData = new FormData();
        const blob = await fetch(file)
        const data = await blob.blob();
        const transcriptUsed = localStorage.getItem('transcript');
        if (transcriptUsed === 'mixed')
            formData.append('transcript', new File([data], "/bank_rm_transcript_mixed.txt"));
        else 
            formData.append('transcript', new File([data], "/bank_rm_transcript.txt"));


        const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
        const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/models/' + usecase + '/session';

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: formData
        })
            .then(response => {
                return response.text();
            })
            .then(data => {
                dataResponse = data;
                callSession(data, usecase);
                // console.log(data);
                // setSessionId(data);
                // fun(data, usecase)
            })
            .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
        return dataResponse;
    };

    const callSession = (session_id, usecase) => {
        const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
        const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/chat/completions?debug=false&session_id=' + session_id;

        const stream = new ReadableStream({
            start(controller) {
                const processResponse = async (response, controller) => {
                    const reader = response.body.getReader();
                    let { done, value } = await reader.read();
                    while (!done) {
                        processChunk(new TextDecoder().decode(value), controller, usecase);
                        ({ done, value } = await reader.read());
                    }
                };

                fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "model": usecase,
                        "messages": [
                            {
                                "role": "system"
                            }
                        ],
                        "max_tokens": 1000,
                        "temperature": 0,
                        "stream": true
                    })
                })
                    .then(response => processResponse(response, controller))
                    .catch(error => console.error('Error fetching data:', error));
            }
        });
    };

    const processChunk = (chunk, controller, usecase) => {
        chunk = remainedData + chunk;

        var chunkArray = chunk.split('\n');
        chunkArray.forEach((item, index) => {
            if (item.includes('choices')) {

                const jsonData = item.split('data: ')[1];
                try {
                    const data = JSON.parse(jsonData);
                    if (data.choices.length > 0) {

                        if (data.choices[0].finish_reason === "stop") {
                            document.getElementById('generatingBtn').style.visibility = 'hidden';
                            document.getElementById('generatingBtn').style.display = 'none'; 
                            setSendToRM(true);                       
                            return;
                        }

                        const newContent = data.choices[0].delta.content;
                        accumulatedData += newContent;
                        console.log(accumulatedData);
                    }

                } catch (e) {
                    if (e === "[DONE]") {
                        controller.close();
                        return;
                    }
                }
            } else {
                remainedData = item;
                // setRemainedData(item);
                if (usecase === "Bank_RM Grading API") {
                    setQAPerfData(accumulatedData);
                    localStorage.setItem('qaPerfData_local', accumulatedData);
                    const extractedData = extractData();
                    setChartData(extractedData);
                    setDataAvailable(true);
                } 
            }
        });
    };
    const qaPerformance = () => {
        toggleGenStateQA()
        //callNextGpt("Bank_RM Grading API", "/bank_rm_transcript.txt");
        const transcriptUsed = localStorage.getItem('transcript');
        if (transcriptUsed === 'mixed')
            callNextGpt("Bank_RM Grading API", "/bank_rm_transcript_mixed.txt");
        else 
            callNextGpt("Bank_RM Grading API", "/bank_rm_transcript.txt");
 
    }
    const toggleGenStateQA = () => {
        setGenstateQA(prevState => (prevState === 'notgen' ? 'gen' : 'notgen'));
    };

    return (
        <div>
            <Row className='perf_breakdown'>
                <Col><h5>QA Performance</h5></Col>
                <Col className='buttoncol' >
                    <div id="generatingBtn">    
                        <button className={`btn ${genstateQA}`} onClick={qaPerformance}>
                            {genstateQA === 'notgen' ? (
                                <div className='notgen'>QA Performance</div>
                            ) : (
                                <div className='gen'>
                                    <Spinner animation="border" size="sm" />Generating
                                </div>
                            )}
                        </button>
                    </div>
                    {
                        isSendtoRM === true &&
                        <div>
                            <button className='btn sendToRm_qa' id="sendToRm">Schedule call with Customer</button><br/>
                            <button className='btn sendToRm_qa' id="sendToRm">Append to RM's Compliance record</button>
                        </div>
                    }               
                </Col>
            </Row>
            <Row>
                <div className="qaPerformanceTable">
                    <Markdown>{qaPerfData}</Markdown>
                </div>
            </Row>
        </div>
    )
}

export default QAPerformance;